<template>
    <div class="d-flex justify-content-between">
        <div class="chart-legend ml-0">
            <div class="legend-item mr-50">
                <div class="legend daily bg-warning"></div>
                <small class="legend text">{{ $t('org.common.Daily') }}</small>
            </div>
            <div class="legend-item ml-1">
                <div class="legend cumulative bg-primary">
                    <div class="cumulative-dot bg-white border-primary"></div>
                </div>
                <small class="legend text">{{ $t('org.common.Cumulative')}}</small>
            </div>
        </div>
        <p v-if="data > 0" class="text-right mb-0 mr-2 text-warning">
            <small>
                * {{ $t('org.billing.costNotExpressedInGraph').replace('{cost}', $_getDollar(data).replace(' ','')) }}
            </small>
        </p>
    </div>
</template>

<script>
export default {
    props: ['data']
}
</script>

<style scoped>
.chart-legend {
    display: flex;
    padding-left: 1.7rem;
}

.legend-item {
    display: flex;
    align-items: center;
}

.legend-item .legend {
    margin-right: 4px;
}

.legend.daily {
    width: 20px;
    height: 10px;
}

.legend.cumulative {
    width: 20px;
    height: 3px;
    position: relative;
}

.legend.cumulative .cumulative-dot {
    width: 8px;
    height: 8px;
    border-radius: 4px;
    border: 1px solid; /* border-primary */
    position: absolute;
    left: 6px;
    top: -2.5px;
}
.legend.text {
    color: #B4B4B4;
}

</style>
